// extracted by mini-css-extract-plugin
export default {"indicator":"indicator","left":"left","right":"right","active":"active","indicator-icon-holder":"indicator-icon-holder"};